module.exports = __webpack_public_path__ + "img/master.3fe7290b.svg";